import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { activateAssetVersion } from '@/services/asset.service';
import { useToast } from '@/components/ui/use-toast';
import { error as errorLog } from '@/utilities/log';
import { QueryKey } from '@/lib/queryKeys';
import { useTranslations } from 'next-intl';

export const useActivateAssetVersion = () => {
  const tToasts = useTranslations('toasts');

  const { toast } = useToast();
  const queryClient = useQueryClient();
  const activateAssetVersionWithAuth = useAuthenticatedQueryFn(activateAssetVersion);

  const activateAssetVersionMutation = useMutation({
    mutationFn: activateAssetVersionWithAuth,
    onSuccess: () => {
      toast({
        title: tToasts('activateAssetVersionMutation.title'),
        description: tToasts('activateAssetVersionMutation.description'),
      });

      void queryClient.invalidateQueries({ queryKey: [QueryKey.Asset] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.AssetData] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.Duplicates] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.ShareList] });
    },
    onError: (err) => {
      errorLog(err);
    },
  });

  return { activateAssetVersionMutation };
};
